// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC2xw2Skl5--o2Cp4OI6zw1_KoNfbJhMCc",
  authDomain: "jobguru-cafe6.firebaseapp.com",
  projectId: "jobguru-cafe6",
  storageBucket: "jobguru-cafe6.firebasestorage.app",
  messagingSenderId: "551364497413",
  appId: "1:551364497413:web:14d76af6dd6e0859c7cc6c",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
